import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactPlaceholder from 'react-placeholder'
import PropTypes from 'prop-types'
import { Showcase } from '../../Showcase'
import { Card, CardPlaceholder } from 'loyal-react'
import { actions as cartActions } from '../../Cart'

class Personalized extends Component {
  constructor (props) {
    super()
  }

  componentDidMount () {
    this.props.fetchUserRecomendation()
  }

  render () {
    return (
      <div className='bx-showcase pos-relative'>
        {this.props.products.length > 0 && (
          <Showcase
            title={this.props.title}
            titleMobile={this.props.titleMobile}
            searchPage='/search'
          >
            {this.props.products.map((p, idx) => (
              <ReactPlaceholder
                ready={!this.props.isLoading}
                customPlaceholder={<CardPlaceholder />}
                key={idx}
              >
                <Card
                  onlyCash={this.props.onlyCash}
                  sellingPrice={
                    p.availability.availability
                      ? p.availability.onlyCash.sellingPrice
                      : 99
                  }
                  sku={p.sku}
                  image={p.imageUrl}
                  description={p.name}
                  priceFrom={
                    p.availability.available
                      ? p.availability.regularPrice.toString()
                      : ''
                  }
                  priceFor={
                    p.availability.available
                      ? p.availability.price.toString()
                      : ''
                  }
                  poinstPlusCash={
                    p.availability.available ? p.availability.cash : null
                  }
                  countDown={p.countDown ? p.countDown : false}
                  vendor={''}
                  percentage={false}
                  addCart={this.props.addItemToCart}
                  itemCart={{
                    sku: p.sku,
                    vendorId: p.vendorId,
                    email: this.props.email
                  }}
                  cart={this.props.cart}
                  available={p.availability && p.availability.available}
                  decimalPlace={this.props.currencyConfiguration.decimalPlaces}
                  pointsName={this.props.currencyConfiguration.pointsName}
                />
              </ReactPlaceholder>
            ))}
          </Showcase>
        )}
      </div>
    )
  }
}

Personalized.propTypes = {
  fetchUserRecomendation: PropTypes.func,
  addItemToCart: PropTypes.func,
  cart: PropTypes.object,
  email: PropTypes.string,
  title: PropTypes.string,
  titleMobile: PropTypes.string,
  products: PropTypes.array,
  isLoading: PropTypes.bool,
  onlyCash: PropTypes.bool,
  currencyConfiguration: PropTypes.object
}

const mapStateToProps = ({ oidc, cart, onlyCash }) => ({
  email: oidc && oidc.user && oidc.user.profile && oidc.user.profile.email,
  cart,
  onlyCash
})

const mapDispathToProps = () => dispatch => ({
  addItemToCart: data => dispatch(cartActions.addItem(data))
})
export default connect(
  mapStateToProps,
  mapDispathToProps
)(Personalized)



// WEBPACK FOOTER //
// ./src/features/Recomendation/Personalized/Personalized.js